import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/skyatlas': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M640 329.3C640 395.2 587.5 443.7 522.5 443.7 356.6 443.7 325.9 194 162.8 194 15.9 194 15.7 406.2 168.4 406.2 210.9 406.2 259.3 388.4 293.7 363.7 299.3 359.6 310.6 347.4 316.5 347.4S327.4 352.4 327.4 358.3C327.4 366.1 314.3 377.4 308.7 382.4 267.8 418 208.4 443.6 154 443.6 70.6 443.7 0 384.6 0 298.7S67.5 149.6 152.8 149.6C338.1 149.6 375.3 395.5 514.7 395.5 614.6 395.5 609.5 255.8 518.1 255.8 500.6 255.8 483.1 267.4 471.2 267.4 462.8 267.4 455.3 260.2 455.3 251.8 455.3 240.2 460.6 228.1 460.6 215.5 460.6 148.9 409.7 100.8 343.7 100.8 290.6 100.8 263.7 137.7 254.9 137.7 248.7 137.7 243.7 132.7 243.7 126.5 243.7 120.9 247.8 116.2 251.5 112.1 276.8 83.3 316.2 68.4 354.3 68.4 433.7 68.4 493.4 126.8 493.4 206.2 493.4 213.1 493.1 219.9 492.2 226.8 504.1 223.7 516.3 222.1 528.1 222.1 588.8 222.1 640 267.4 640 329.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/skyatlas.js
// module id = qZty
// module chunks = 144